import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Z_INDEX } from 'enums/form-enums';
import { COLORS } from 'styles/theme/colors';

export const TableContainer = ({ children, tabs }) => {
  return <TableContainer.Body tabs={tabs}>{children}</TableContainer.Body>;
};

TableContainer.Body = styled.div`
  position: relative;
  width: 100%;
  min-width: 754px;
  min-height: 100px;
  background-color: ${COLORS.primaryBackground};
  margin-top: 32px;
  border: 1px solid ${COLORS.primaryTableBorder};
  z-index: ${Z_INDEX.TABLE_CONTAINER};
`;

TableContainer.propTypes = {
  children: PropTypes.node,
  tabs: PropTypes.bool,
};

export default TableContainer;
